import { CompanyCard, CompanyCardStatus, TachographCompanyCardRow } from "../models/Tachograph";
import { parseDateOrNull } from "./tachographDates";

export function normalizeCompanyCardStatus(value?: string): CompanyCardStatus {
  const normalized = value?.trim().toLowerCase();
  if (normalized === "busy") return "busy";
  if (normalized === "offline") return "offline";
  if (normalized === "available") return "available";

  return "unknown";
}

type CompanyCardRowOptions = {
  search: string;
  formatStatus: (status: CompanyCardStatus) => string;
};

/**
 * The rows of the company card tab, sorted by card number. Cards that are busy or disconnected
 * stay in the list with their status — those are the ones somebody has to act on.
 */
export function buildCompanyCardRows(
  cards: CompanyCard[],
  { search, formatStatus }: CompanyCardRowOptions,
): TachographCompanyCardRow[] {
  const normalizedSearch = search.trim().toLowerCase();

  return cards
    .filter(card => {
      if (!normalizedSearch) return true;

      const haystack = `${card.cardNumber ?? ""} ${card.companyName ?? ""} ${card.source ?? ""}`.toLowerCase();

      return haystack.includes(normalizedSearch);
    })
    .map(card => {
      const validity = parseDateOrNull(card.validity);
      const expiry = parseDateOrNull(card.expiry);
      const lastUpdate = parseDateOrNull(card.lastUpdate);

      return {
        id: card.id ?? card.cardNumber ?? `${card.companyName ?? "company"}-${card.icc ?? "icc"}`,
        cardNumber: card.cardNumber ?? "",
        companyName: card.companyName ?? "",
        icc: card.icc != null ? String(card.icc) : "",
        status: formatStatus(normalizeCompanyCardStatus(card.status)),
        source: card.source ?? "",
        validFrom: validity,
        expiryDateUtc: expiry,
        lastUpdate: lastUpdate,
      };
    })
    .sort((a, b) => a.cardNumber.localeCompare(b.cardNumber));
}
